<template>
  <div class="productVariants">
    <div class="productVariants__list">
      <div class="productVariants__itemWrapper" v-for="item in variants" :key="item.slug">
        <div @mouseenter="changeVariant(item.slug)" @mouseleave="defaultVariant">
          <nuxt-link
            class="productVariants__item"
            :class="{ 'productVariants__item--active': item.isCurrent }"
            :to="localePath({ name: 'product-slug', params: { slug: item.slug } })"
            @click.native="gTagProductClick(item)"
            offset="20"
            v-v-tooltip="{
              content: `${item.tags
                .map(tag => {
                  return `<div><b>${tag.name}</b>: ${tag.value}</div>`;
                })
                .join('')}`,
              offset: 10,
            }"
          >
            <div class="productVariants__itemImage">
              <new-image-box
                :alt="item.name"
                :src="item.mainPictureUrl150x150"
                :width="70"
                :height="70"
                loading="eager"
                :image-params="'w_70,h_70'"
                center-image
              />
            </div>
          </nuxt-link>
        </div>
      </div>
    </div>
    <template v-if="hoverVariant">
      <div
        :key="index"
        class="productVariants__current"
        v-for="(variantTag, index) in hoverVariant.tags"
      >
        <span class="productVariants__currentName">{{ variantTag.name }}:</span>
        <span class="productVariants__currentValue">{{ variantTag.value }}</span>
      </div>
    </template>
  </div>
</template>

<script>
import { VClosePopover, VPopover, VTooltip } from 'v-tooltip';
import NewImageBox from '@/components/NewImageBox';
export default {
  name: 'ProductVariants',
  components: { NewImageBox, VPopover },
  directives: {
    closePopover: VClosePopover,
    vTooltip: VTooltip,
  },
  props: {
    variants: {
      type: Array,
      default: () => {},
    },
    activeProduct: {
      type: String,
      default: '',
    },
    product: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      hoverVariant: [],
    };
  },
  computed: {
    currentVariant() {
      return this.variants.find(obj => {
        return obj.isCurrent === true;
      });
    },
  },
  created() {
    this.defaultVariant();
  },
  methods: {
    gTagProductClick(item) {
      const categories = this.product.category.namesInPath.reduce((acc, curr, index) => {
        acc['category' + (index === 0 ? '' : index + 1)] = curr;
        return acc;
      }, {});

      this.$gtm.push({ ecommerce: null });
      this.$gtm.push({
        event: 'select_item',
        ecommerce: {
          item_list_id: '',
          item_list_name: '',
          items: [
            {
              item_id: item.id,
              item_name: item.name,
              discount: item.priceBeforeDiscountObject
                ? this.$helper.calculateDiscount(
                    item.priceBeforeDiscountObject.gross,
                    item.priceObject.gross,
                  )
                : 0,
              brand: item.brand ? item.brand.name : '',
              ...categories,
              item_list_id: '',
              item_list_name: '',
              promotion_id: item?.promotion?.id ?? '',
              promotion_name: item?.promotion?.name ?? '',
              price: item.priceObject.gross,
              variant: '',
              quantity: 1,
            },
          ],
        },
      });
    },
    changeVariant(slug) {
      this.hoverVariant = this.variants.find(obj => {
        return obj.slug === slug;
      });
      this.$emit('change-variant', this.hoverVariant);
    },
    defaultVariant() {
      this.hoverVariant = this.currentVariant;
      this.$emit('change-variant', undefined);
    },
  },
};
</script>

<style lang="scss">
.productVariants {
  &__current {
    margin-bottom: 0.5rem;
    font-size: 1.4rem;
    line-height: 1.8rem;
    letter-spacing: 0.05em;
  }

  &__currentName {
    color: $cAddDark02;
  }

  &__list {
    margin-top: 2rem;
    display: flex;
    flex-wrap: wrap;
    margin-left: -5px;
    margin-right: -5px;
  }

  &__itemWrapper {
    padding: 0 3px 6px 3px;
    flex: 0 0 16.666%;

    @include rwd('large-tablet') {
      flex: 0 0 20%;
    }

    @include rwd('tablet') {
      flex: 0 0 16.666%;
    }

    @include rwd('small-tablet') {
      flex: 0 0 20%;
    }
  }

  &__item {
    display: flex;
    align-items: center;
    justify-content: center;
    aspect-ratio: 1 / 1;
    padding: 7px;
    border: 1px solid $cAddLight;
    border-radius: 4px;
    transition: border $tr;

    &--active,
    &:hover {
      border: 1px solid $cAddDark;
    }
  }

  &__itemImage {
    max-width: 100%;
    max-height: 100%;
    height: 100%;
  }
}
</style>
